import moment from "moment";
import { minValue } from "react-admin";
const normalizeDate = (value) => {
  if (!value) {
    return null;
  }

  const date = moment(value);
  if (!date.isValid()) {
    return null;
  }

  return date.startOf("day");
};

const validateDateNotFuture =
  (message = "resources.messages.date_not_future") =>
  (value) => {
    const selectedDate = normalizeDate(value);
    const today = moment().startOf("day");

    if (!selectedDate) {
      return undefined;
    }

    if (selectedDate.isAfter(today)) {
      return message;
    }

    return undefined;
  };

const validateDateMustBeMoreThanToday =
  (message = "resources.messages.date_not_future") =>
  (value) => {
    const selectedDate = normalizeDate(value);
    const today = moment().startOf("day");

    if (!selectedDate) {
      return undefined;
    }

    if (selectedDate.isSameOrBefore(today)) {
      return message;
    }

    return undefined;
  };

const validateDateMustBeMoreThanCreatedAt =
  ({
    compareField = "created_at",
    message = "resources.messages.date_not_future",
  } = {}) =>
  (value, allValues) => {
    const selectedDate = normalizeDate(value);
    const compareValue =
      allValues && typeof allValues.get === "function"
        ? allValues.get(compareField)
        : allValues?.[compareField];
    const createdAtDate = normalizeDate(compareValue);

    if (!selectedDate || !createdAtDate) {
      return undefined;
    }

    if (selectedDate.isSameOrBefore(createdAtDate)) {
      return message;
    }

    return undefined;
  };

const validateMinValue = (createAt, message) => {
  if (createAt && createAt !== "") {
    return minValue(moment(createAt).format("YYYY-MM-DD"), message);
  } else {
    return minValue(moment().format("YYYY-MM-DD"), message);
  }
};

export {
  validateDateNotFuture,
  validateDateMustBeMoreThanToday,
  validateDateMustBeMoreThanCreatedAt,
  validateMinValue,
};
